import { render, staticRenderFns } from "./UserslistPage.vue?vue&type=template&id=f2aa4b72&scoped=true&"
import script from "./UserslistPage.vue?vue&type=script&lang=js&"
export * from "./UserslistPage.vue?vue&type=script&lang=js&"
import style0 from "./UserslistPage.vue?vue&type=style&index=0&id=f2aa4b72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aa4b72",
  null
  
)

component.options.__file = "UserslistPage.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VContainer,
  VDataTable,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VProgressLinear,
  VSnackbar,
  VSpacer,
  VTextField,
})
